import { render, staticRenderFns } from "./CreateLineupForm.vue?vue&type=template&id=1873bcab&"
import script from "./CreateLineupForm.vue?vue&type=script&lang=ts&"
export * from "./CreateLineupForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateLineupForm.vue?vue&type=style&index=0&id=1873bcab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports